<template>
  <div :class="$style.wrapper">
    <slot />
  </div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.wrapper {
  margin-top: $space-100;
  margin-bottom: $space-150;

  @include grid-media-query(sm) {
    margin-top: 0;
  }
}
</style>
<script setup lang="ts"></script>
